export var HangingType;
(function (HangingType) {
    HangingType["CLIPS"] = "clips";
    HangingType["CLEATS"] = "cleats";
})(HangingType || (HangingType = {}));
